import { createEntityAdapter, createSlice, EntityState, PayloadAction } from "@reduxjs/toolkit";
import { isEqual, keyBy, merge } from "lodash";

import Graph_QL, { DynamicDataObk } from "../..";
import { FeedCurve } from "../GQLCalls/getFeedCurvesCall";


export type FeedCurveItem = DynamicDataObk<FeedCurve[]>

const feedCurvesDataAdapter = createEntityAdapter({
  selectId: (item: FeedCurveItem) => Graph_QL.ObjToString(item.con)
});

const mergePayloadAndState = (state: EntityState<FeedCurveItem, string>, {con, data}: FeedCurveItem) => {
  const identifier = Graph_QL.ObjToString(con);
  if (state.entities[identifier]) {
    const existingData = state.entities[identifier].data;
    const dataDictionary = keyBy(state.entities[identifier].data, "feedCurveId")
    data.forEach((entry) => dataDictionary[entry.feedCurveId] = entry)
    const newPayload = {con, data: Object.values(dataDictionary)}
    if (newPayload.data.length !== existingData.length || !isEqual(existingData, newPayload.data) ) {
      feedCurvesDataAdapter.upsertOne(state, newPayload);
    }
  } else { feedCurvesDataAdapter.addOne(state, {con, data})}
}

const updatePayloadAndState = (state: EntityState<FeedCurveItem, string>, {con, data}: FeedCurveItem) => {
  const identifier = Graph_QL.ObjToString(con);
  if (state.entities[identifier]) {
    const existingData = state.entities[identifier].data;
    const dataDictionary = keyBy(state.entities[identifier].data, "feedCurveId")
    data.forEach((entry) => dataDictionary[entry.feedCurveId] = merge({}, entry, dataDictionary[entry.feedCurveId]));
    const newPayload = {con, data: Object.values(dataDictionary)}
    if (newPayload.data.length !== existingData.length || !isEqual(existingData, newPayload.data) ) {
      feedCurvesDataAdapter.upsertOne(state, newPayload);
    }
  } else { feedCurvesDataAdapter.addOne(state, {con, data})}
}

const removeDeletedFromState = (state: EntityState<FeedCurveItem, string>, {con, data}: FeedCurveItem) => {
  const identifier = Graph_QL.ObjToString(con);
  if (state.entities[identifier]) {
    const idsToRemove = data.map((feedCurve) => (feedCurve.feedCurveId));
    const newPayload = {con, data: state.entities[identifier].data.filter((feedCurve) => !idsToRemove.includes(feedCurve.feedCurveId))}
    feedCurvesDataAdapter.upsertOne(state, newPayload);
  }
}

/**
 * @deprecated
 */
const feedCurvesSlice = createSlice({
  name: "feedCurves/old",
    initialState: feedCurvesDataAdapter.getInitialState<FeedCurveItem[]>([]),
      reducers: {
        maintained: (state, {payload}:PayloadAction<FeedCurveItem>) => {
          mergePayloadAndState(state, payload);
        },
        update: (state, {payload}: PayloadAction<FeedCurveItem>) => {
          updatePayloadAndState(state, payload);
        },
        deleted: (state, {payload}:PayloadAction<FeedCurveItem>) => {
          removeDeletedFromState(state, payload)
      },
    }
})

/**
 * @deprecated
 */
export const FeedCurvesActions = feedCurvesSlice.actions;
export default feedCurvesSlice.reducer;